import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/shared-menu/Navbar';

const NotFound = () => {
  const navigate = useNavigate();

  return (
      <>
        <Navbar />
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          height="100vh"
          bgcolor="#f8fafc"
        >
          <SentimentVeryDissatisfiedIcon
            sx={{
              fontSize: 100,
              color: '#bdbdbd',
              mb: 2,
              animation: 'shake 1.2s infinite alternate',
              '@keyframes shake': {
                '0%': { transform: 'rotate(-10deg)' },
                '100%': { transform: 'rotate(10deg)' },
              },
            }}
          />
          <Typography variant="h2" color="error" gutterBottom>
            404
          </Typography>
          <Typography variant="h5" gutterBottom>
            Oops! The page you are looking for does not exist.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            sx={{ mt: 3 }}
            onClick={() => navigate('/')}
          >
            Go Home
          </Button>
        </Box>
  
      </>
    );
};

export default NotFound;